import { useRef, useState, useEffect } from "react";
import { CiPause1, CiPlay1, CiVolume } from "react-icons/ci";

const AudioPlayer = ({ src }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    const audio = audioRef.current;

    const updateTime = () => {
      setProgress(audio.currentTime);
    };

    const setAudioData = () => {
      setDuration(audio.duration);
    };

    audio.addEventListener("timeupdate", updateTime);
    audio.addEventListener("loadedmetadata", setAudioData);

    return () => {
      audio.removeEventListener("timeupdate", updateTime);
      audio.removeEventListener("loadedmetadata", setAudioData);
    };
  }, []);

  const handleSeek = (e) => {
    const time = e.target.value;
    audioRef.current.currentTime = time;
    setProgress(time);
  };

  const formatTime = (time) => {
    if (isNaN(time)) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  return (
    <div className="flex items-center gap-3 w-full p-3 rounded-xl border bg-white shadow-sm  dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100">
      {/* Hidden Audio */}
      <audio ref={audioRef} src={src} />

      {/* Play/Pause Button */}
      <button
        onClick={togglePlay}
        className="p-2 rounded-full bg-brand-500 text-white hover:bg-brand-600 transition  dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
      >
        {isPlaying ? <CiPause1 size={15} /> : <CiPlay1 size={15} />}
      </button>

      {/* Progress Bar */}
      <input
        type="range"
        min="0"
        // max={duration}
        value={progress}
        onChange={handleSeek}
        className="flex-1 accent-blue-500"
      />

      {/* Time */}
      <span className="text-xs text-gray-600 w-12 text-right">
        {formatTime(progress)} / {formatTime(duration)}
      </span>
    </div>
  );
};

export default AudioPlayer;
